/**
 * pages.config.js - Page routing configuration
 *
 * Pages are auto-registered when you create files in the ./pages/ folder.
 *
 * Non-home pages are converted to lazy imports at compile time by
 * scripts/lazy-route-pages.mjs (vite.config.js): the generated file stays
 * exactly as written here, and only the page being visited is downloaded.
 * Home stays eager so the landing page never waits on a second round trip.
 *
 * THE ONLY EDITABLE VALUE: mainPage
 * The mainPage value must match a key in the PAGES object exactly.
 */

import Home from './pages/Home';
import About from './pages/About';
import AccessibilityStatement from './pages/AccessibilityStatement';
import AllOn4NewPortRicheyFL from './pages/AllOn4NewPortRicheyFL';
import AllOn4TrinityFL from './pages/AllOn4TrinityFL';
import AllOnX from './pages/AllOnX';
import Blog from './pages/Blog';
import BoneGrafting from './pages/BoneGrafting';
import BookAppointment from './pages/BookAppointment';
import BrooksvilleFL from './pages/BrooksvilleFL';
import ClearwaterFL from './pages/ClearwaterFL';
import ContactUs from './pages/ContactUs';
import CosmeticDentistTampaFL from './pages/CosmeticDentistTampaFL';
import CosmeticDentistry from './pages/CosmeticDentistry';
import DentalAssessment from './pages/DentalAssessment';
import DentalImplants from './pages/DentalImplants';
import DentalImplantsAssessment from './pages/DentalImplantsAssessment';
import DentalImplantsFAQ from './pages/DentalImplantsFAQ';
import DentalInsurance from './pages/DentalInsurance';
import DentalImplantsNearTrinityCollegeFL from './pages/DentalImplantsNearTrinityCollegeFL';
import DentalImplantsNearTrinityCommonsFL from './pages/DentalImplantsNearTrinityCommonsFL';
import DentalImplantsTrinityEastFL from './pages/DentalImplantsTrinityEastFL';
import DentalImplantsTrinityFL from './pages/DentalImplantsTrinityFL';
import DentalImplantsTrinityPreserveFL from './pages/DentalImplantsTrinityPreserveFL';
import DentalImplantsTrinityWestFL from './pages/DentalImplantsTrinityWestFL';
import DunedinFL from './pages/DunedinFL';
import EmergencyDentistClearwaterFL from './pages/EmergencyDentistClearwaterFL';
import EmergencyDentistry from './pages/EmergencyDentistry';
import FinancingOptions from './pages/FinancingOptions';
import FixedNewTeeth from './pages/FixedNewTeeth';
import FullMouthRestoration from './pages/FullMouthRestoration';
import GeneralDentistry from './pages/GeneralDentistry';
import HolidayFL from './pages/HolidayFL';
import Invisalign from './pages/Invisalign';
import InvisalignTrinityFL from './pages/InvisalignTrinityFL';
import KeystoneFL from './pages/KeystoneFL';
import LandOLakesFL from './pages/LandOLakesFL';
import LaserDentistry from './pages/LaserDentistry';
import LutzFL from './pages/LutzFL';
import MeetTheDoctor from './pages/MeetTheDoctor';
import DentistNewPortRicheyFL from './pages/DentistNewPortRicheyFL';
import OdessaFL from './pages/OdessaFL';
import OldsmarFL from './pages/OldsmarFL';
import OralSurgery from './pages/OralSurgery';
import OurResults from './pages/OurResults';
import OurTechnology from './pages/OurTechnology';
import PalmHarborFL from './pages/PalmHarborFL';
import PatientEducation from './pages/PatientEducation';
import PeriodontalDiseaseTreatment from './pages/PeriodontalDiseaseTreatment';
import PortRicheyFL from './pages/PortRicheyFL';
import PreventativeDentistry from './pages/PreventativeDentistry';
import PrivacyPolicy from './pages/PrivacyPolicy';
import OfficePolicies from './pages/OfficePolicies';
import RegenerativeDentistry from './pages/RegenerativeDentistry';
import Resources from './pages/Resources';
import SameDayCrowns from './pages/SameDayCrowns';
import SedationDentistry from './pages/SedationDentistry';
import Services from './pages/Services';
import SingleImplant from './pages/SingleImplant';
import SinusGrafts from './pages/SinusGrafts';
import SmileVisualizer from './pages/SmileVisualizer';
import SpringHillFL from './pages/SpringHillFL';
import StPetersburgFL from './pages/StPetersburgFL';
import TampaFL from './pages/TampaFL';
import TarponSpringsFL from './pages/TarponSpringsFL';
import TermsOfService from './pages/TermsOfService';
import TrinityFL from './pages/TrinityFL';
import VeneersPalmHarborFL from './pages/VeneersPalmHarborFL';
import WesleyChapelFL from './pages/WesleyChapelFL';
import WestchaseFL from './pages/WestchaseFL';
import ZephyrhillsFL from './pages/ZephyrhillsFL';
import __Layout from './Layout.jsx';

export const PAGES = {
    "Home": Home,
    "About": About,
    "AccessibilityStatement": AccessibilityStatement,
    "AllOn4NewPortRicheyFL": AllOn4NewPortRicheyFL,
    "AllOn4TrinityFL": AllOn4TrinityFL,
    "AllOnX": AllOnX,
    "Blog": Blog,
    "BoneGrafting": BoneGrafting,
    "BookAppointment": BookAppointment,
    "BrooksvilleFL": BrooksvilleFL,
    "ClearwaterFL": ClearwaterFL,
    "ContactUs": ContactUs,
    "CosmeticDentistTampaFL": CosmeticDentistTampaFL,
    "CosmeticDentistry": CosmeticDentistry,
    "DentalAssessment": DentalAssessment,
    "DentalImplants": DentalImplants,
    "DentalImplantsAssessment": DentalImplantsAssessment,
    "DentalImplantsFAQ": DentalImplantsFAQ,
    "DentalInsurance": DentalInsurance,
    "DentalImplantsNearTrinityCollegeFL": DentalImplantsNearTrinityCollegeFL,
    "DentalImplantsNearTrinityCommonsFL": DentalImplantsNearTrinityCommonsFL,
    "DentalImplantsTrinityEastFL": DentalImplantsTrinityEastFL,
    "DentalImplantsTrinityFL": DentalImplantsTrinityFL,
    "DentalImplantsTrinityPreserveFL": DentalImplantsTrinityPreserveFL,
    "DentalImplantsTrinityWestFL": DentalImplantsTrinityWestFL,
    "DentistNewPortRicheyFL": DentistNewPortRicheyFL,
    "DunedinFL": DunedinFL,
    "EmergencyDentistClearwaterFL": EmergencyDentistClearwaterFL,
    "EmergencyDentistry": EmergencyDentistry,
    "FinancingOptions": FinancingOptions,
    "FixedNewTeeth": FixedNewTeeth,
    "FullMouthRestoration": FullMouthRestoration,
    "GeneralDentistry": GeneralDentistry,
    "HolidayFL": HolidayFL,
    "Invisalign": Invisalign,
    "InvisalignTrinityFL": InvisalignTrinityFL,
    "KeystoneFL": KeystoneFL,
    "LandOLakesFL": LandOLakesFL,
    "LaserDentistry": LaserDentistry,
    "LutzFL": LutzFL,
    "MeetTheDoctor": MeetTheDoctor,
    "OdessaFL": OdessaFL,
    "OfficePolicies": OfficePolicies,
    "OldsmarFL": OldsmarFL,
    "OralSurgery": OralSurgery,
    "OurResults": OurResults,
    "OurTechnology": OurTechnology,
    "PalmHarborFL": PalmHarborFL,
    "PatientEducation": PatientEducation,
    "PeriodontalDiseaseTreatment": PeriodontalDiseaseTreatment,
    "PortRicheyFL": PortRicheyFL,
    "PreventativeDentistry": PreventativeDentistry,
    "PrivacyPolicy": PrivacyPolicy,
    "RegenerativeDentistry": RegenerativeDentistry,
    "Resources": Resources,
    "SameDayCrowns": SameDayCrowns,
    "SedationDentistry": SedationDentistry,
    "Services": Services,
    "SingleImplant": SingleImplant,
    "SinusGrafts": SinusGrafts,
    "SmileVisualizer": SmileVisualizer,
    "SpringHillFL": SpringHillFL,
    "StPetersburgFL": StPetersburgFL,
    "TampaFL": TampaFL,
    "TarponSpringsFL": TarponSpringsFL,
    "TermsOfService": TermsOfService,
    "TrinityFL": TrinityFL,
    "VeneersPalmHarborFL": VeneersPalmHarborFL,
    "WesleyChapelFL": WesleyChapelFL,
    "WestchaseFL": WestchaseFL,
    "ZephyrhillsFL": ZephyrhillsFL,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};